import { api } from "./api.v2";

export const funcionariosService = {
  getFuncionarios: async (params) => {
    return api.get("/users", { params });
  },
  
  getPermissions: async (userId) => {
    return api.get(`/permissions/user/${userId}`);
  },

  updatePermissions: async (userId, payload) => {
    return api.put(`/permissions/user/${userId}`, payload);
  }
};
